import React from 'react';
import { motion } from 'framer-motion';
import './Testimonials.css';

const TESTIMONIALS = [
  {
    name: 'Priya Sharma',
    since: 'Student since 2022',
    text: 'Joining Yogsadhna Varga was the best decision I made for my health. My back pain reduced significantly within a month, and I feel more energetic throughout the day.',
    avatar: 'PS'
  },
  {
    name: 'Sunita Deshmukh',
    since: 'Student since 2021',
    text: 'The classes here are so calming and well-structured. Madam gives personal attention to each student. My stress levels have dropped completely since I started.',
    avatar: 'SD'
  },
  {
    name: 'Kavita Joshi',
    since: 'Student since 2023',
    text: 'I lost 6 kg in 3 months through Surya Namaskar and pranayama. More importantly, I sleep much better now. Highly recommend to all ladies!',
    avatar: 'KJ'
  },
  {
    name: 'Rekha Patil',
    since: 'Student since 2020',
    text: 'I have been practising here for 4 years. The environment is very positive and supportive. It feels like a family. My thyroid levels have also improved.',
    avatar: 'RP'
  }
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.12, duration: 0.5, ease: 'easeOut' } })
};

const Testimonials = () => (
  <section className="testimonials-section" id="testimonials">
    <motion.div
      className="testimonials-header"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="testimonials-title">What Our Students Say</h2>
      <p className="testimonials-subtitle">Real experiences from ladies at Yogsadhna Varga</p>
    </motion.div>

    <div className="testimonials-grid">
      {TESTIMONIALS.map((t, i) => (
        <motion.div
          key={t.name}
          className="testimonial-card"
          custom={i}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={cardVariants}
        >
          <div className="testimonial-quote">"</div>
          <p className="testimonial-text">{t.text}</p>
          <div className="testimonial-author">
            <div className="testimonial-avatar">{t.avatar}</div>
            <div>
              <div className="testimonial-name">{t.name}</div>
              <div className="testimonial-since">{t.since}</div>
            </div>
          </div>
          <div className="testimonial-stars">★★★★★</div>
        </motion.div>
      ))}
    </div>
  </section>
);

export default Testimonials;
